import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { dispatch } from "../../../../store/store";
import { ProcedureTabs } from "../../components/ProcedureTabs/ProcedureTabs";
import { PROVIDER_ROOM_PROCEDURE_TYPE } from "../../../../api/queries/useProviderRoomProceduresQuery";
import { useTableCosmetic } from "../hooks/useTableCosmetic";
import { Table } from "../../../../shared/Table/Table";
import parentClasses from "../../sass/ProviderRoom.module.scss";
import ReactSelect from "../../../../Components/Common/ReactSelect";
import { Button } from "../../../../shared/Button/Button";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { providerRoom } from "../../../../store/providerRoom";
import { Checkbox } from "../../../../shared/Checkbox/Checkbox";

const mapStateToProps = (state) => ({
  signList: providerRoom.selectors.selectProceduresSignList(state),
});

export const TabCosmetic = connect(mapStateToProps)(
  ({
    onChangeTab,
    isVisible,
    procedures,
    availableClinicsList = [],
    onChangeClinic,
    isShowAllProcedures,
    onChangeShowAllProcedures,
    clinicId,
    showHideActionButton,
    providerUserId,
    isSigning,
    signList,
    isSigned,
  }) => {
    const { tPr } = useAppTranslation.ProviderRoom();
    const { cols, data, resetSelected } = useTableCosmetic({
      procedures,
      showHideActionButton,
      providerUserId,
      signList,
    });

    const handleChangeTab = (type) => {
      onChangeTab(type);
      resetSelected();
      onChangeClinic("");
    };

    const handleSign = () => {
      dispatch(
        providerRoom.actions.signProceduresDataChange({
          procedureIds: signList.map(Number),
          isSendToMd: true,
        }),
      );
    };

    const handleClinicChange = ({ id }) => {
      onChangeClinic(id.toString());
    };

    useEffect(() => {
      if (isSigned && signList.length > 0) {
        resetSelected();
      }
    }, [isSigned, signList]);

    return (
      <>
        <div className={parentClasses.procedureTabsRow}>
          <ProcedureTabs
            value={PROVIDER_ROOM_PROCEDURE_TYPE.cosmetic}
            onChange={handleChangeTab}
          />
          <Checkbox
            size="small"
            isChecked={isShowAllProcedures}
            onChange={onChangeShowAllProcedures}
            label={tPr("label.showAll")}
          />
          <div className="col-12 col-sm-5 col-md-4 col-lg-3 p-r-0">
            <ReactSelect
              name={"id"}
              selectedId={clinicId}
              list={[
                { name: "All Clinics", id: "" },
                ...availableClinicsList,
              ].map((i) => ({
                value: i.id,
                label: i.name,
              }))}
              value={"value"}
              label={"label"}
              handleReactSelect={handleClinicChange}
              isValid={true}
              placeholder={"Select Clinic"}
              isMulti={false}
            />
          </div>
          {!showHideActionButton && (
            <Button
              size="small"
              onClick={() => handleSign()}
              isDisabled={signList.length === 0 || isSigning}
            >
              {tPr("label.sendToMd")} ({signList.length})
            </Button>
          )}
        </div>

        {isVisible && (
          <Table
            bgColor="white"
            cols={cols}
            data={data}
            headClassName={parentClasses.tableHead}
          />
        )}
      </>
    );
  },
);

TabCosmetic.propTypes = {
  onChangeTab: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  procedures: PropTypes.array.isRequired,
};
